import LocalizedMessage from '../../common/LocalizedMessage';
/* eslint-disable linebreak-style */
/* eslint-disable quotes */
import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from 'react-i18next';

const ContactForm = ({
  email, desc, errors, onSubmit, onChange, disabled, hideIntro
}) => {
  const { t: tr } = useTranslation();
  const isValid = error => (error ? "is-invalid" : "");
  return (
    <div>
      {!hideIntro && (
        <>
          <h2 className="contact-page-title">{tr("public:haveAQuestion_31")}</h2>
          <p>{tr("public:leaveAMessageWeAreAlwaysHappyToAnswer_32")}</p>
        </>
      )}
      <form id="contact-form" onSubmit={onSubmit}>
        <div className="form-row">
          <div className="col-lg-12 mb-1  ">
            <div className="input-group">
              <input
                type="text"
                name="email"
                className={`form-control ${isValid(errors.email)}`}
                value={email}
                onChange={onChange}
                id="email-input"
                placeholder={tr("public:emailAddress_33")}
              />
              <div className="invalid-feedback"><LocalizedMessage isError value={errors.email} /></div>
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="col-lg-12">
            <div className="form-group">
              <textarea
                type="text"
                name="desc"
                autoComplete="off"
                value={desc}
                onChange={onChange}
                id="description-input"
                rows="3"
                placeholder={tr("public:message_34")}
                className={`form-control ${isValid(errors.desc)}`}
              />
              <div className="invalid-feedback"><LocalizedMessage isError value={errors.desc} /></div>
            </div>
          </div>
        </div>
        <button type="submit" className="btn btn-danger font-weight-bold btn-block" style={{ background: "#c91f27" }} disabled={disabled}>{tr("public:sendMessage_35")}</button>
      </form>
    </div>
  );
};

ContactForm.propTypes = {
  email: PropTypes.string.isRequired,
  desc: PropTypes.string.isRequired,
  errors: PropTypes.objectOf(PropTypes.string).isRequired,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  hideIntro: PropTypes.bool
};

ContactForm.defaultProps = {
  hideIntro: false
};

export default ContactForm;
